/**
 * Địa chỉ đầy đủ của HSNL NCC — "giống ngoài danh sách" theo yêu cầu.
 *
 * Đo dữ liệu thật trên KIOS dev: `addressDetail` ở API chi tiết ĐÃ chứa sẵn xã/phường và tỉnh/TP,
 * và trùng khít với `address` mà API danh sách trả về
 * (vd "Lô BT1, Ngõ 191, Đường Phúc Lợi, Phường Phúc Lợi, Thành phố Hà Nội").
 * Vì vậy cứ ghép thêm `wardName`/`cityName` là NHÂN ĐÔI đuôi địa chỉ.
 *
 * Nên: dùng nguyên `addressDetail`, chỉ thêm phần nào thực sự còn thiếu — phòng khi KIOS đổi cách
 * lưu hoặc gặp bản ghi cũ chỉ có số nhà.
 */
export const buildFullAddress = (parts: {
  addressDetail?: string | null;
  wardName?: string | null;
  cityName?: string | null;
}): string => {
  const base = (parts.addressDetail || '').trim();
  const tail = [parts.wardName, parts.cityName]
    .map((p) => (p || '').trim())
    .filter(Boolean)
    // So khớp không phân biệt hoa thường để không bỏ sót bản ghi lệch kiểu chữ.
    .filter((p) => !base.toLowerCase().includes(p.toLowerCase()));

  return [base, ...tail].filter(Boolean).join(', ');
};
